import { createApiRef } from '@backstage/core-plugin-api';
import {
  UserAppliancesResponse,
  RegisterApplianceResponse,
  UserCredentials,
  ApplianceCapabilitiesWithValuesResponse,
  RegisterRequest,
  SendCommandRequest,
  ApplianceStateResponse,
  SendCommandResponse,
  FirmwareApplianceResponse,
  UpdateFirmwareRequest,
} from './types';

/** @public */
export const ApplianceDebuggerApiRef = createApiRef<ApplianceDebuggerApi>({
  id: 'backstage.plugin.appliance-debugger.service',
});

/** @public */
export interface ApplianceDebuggerApi {
  postUserAppliances(
    credentials: UserCredentials,
  ): Promise<UserAppliancesResponse>;
  registerAppliance(
    request: RegisterRequest,
    applianceId: string,
  ): Promise<RegisterApplianceResponse>;
  getApplianceCapabilitiesWithValues(
    applianceId: string,
  ): Promise<ApplianceCapabilitiesWithValuesResponse>;
  getApplianceState(applianceId: string): Promise<ApplianceStateResponse>;
  sendCommand(
    applianceId: string,
    request: SendCommandRequest,
    handler: string | undefined,
  ): Promise<SendCommandResponse>;
  getFirmwareByApplianceId(
    applianceId: string,
    cdcId: string,
  ): Promise<FirmwareApplianceResponse>;
  updateFirmware(
    applianceId: string,
    request: UpdateFirmwareRequest,
  ): Promise<SendCommandResponse>;
}
